import React, { useEffect } from "react"
import { IconButton, Tooltip } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { headerIconButtonSx } from "@components"
import { dsColorNew } from "@palette"

/**
 * Support chat (Slaask), opened from a fixed button in the header instead
 * of Slaask's floating bubble: same widget key and the same identity as the
 * old `@ui-seeker/slaask-plugin`, with `hide_button` so the bubble (and the
 * greeting it pops up beside it) is not drawn, and the table headers' navy for the
 * window instead of the colour set in Slaask.
 */
const WIDGET_KEY = 'spk-d2358d18-33fd-40da-8da6-25fcf50b7577'
const SCRIPT_ID = 'slaask-chat-script'

export function SupportChatLoader({ name }) {
	useEffect(() => {
		if (!name || document.getElementById(SCRIPT_ID)) return
		const script = document.createElement('script')
		script.id = SCRIPT_ID
		script.src = 'https://cdn.slaask.com/chat.js'
		script.async = true
		script.onload = () => {
			window._slaask.identify({ id: name, name })
			window._slaask.init(WIDGET_KEY, { hide_button: true, color: dsColorNew.tableHead })
		}
		document.body.appendChild(script)
	}, [name])

	return null
}

const toggleSupportChat = () => {
	const slaask = window._slaask
	if (!slaask) return
	if (slaask.isOpened?.()) slaask.hide()
	else slaask.show()
}

export default function SupportChatButton() {
	return <Tooltip title="Support chat" arrow>
		<IconButton onClick={toggleSupportChat} sx={headerIconButtonSx} aria-label="Support chat">
			<IconSeeker icon="headset" sx={{ fontSize: 16 }}/>
		</IconButton>
	</Tooltip>
}
